/**
 * Demo mode: `?demo=1` in the URL turns it on for the browser tab (sessionStorage),
 * `?demo=off` turns it off. Fixtures live in src/dev/demoMock.ts.
 * Always false in production builds, so a stray `?demo=1` cannot mislead real users.
 */
const STORAGE_KEY = 'trainer-demo';

export function isDemoMode(): boolean {
  if (process.env.NODE_ENV === 'production') return false;
  try {
    if (typeof window !== 'undefined') {
      const param = new URLSearchParams(window.location.search).get('demo');
      if (param === 'off') {
        sessionStorage.removeItem(STORAGE_KEY);
      } else if (param === '1') {
        sessionStorage.setItem(STORAGE_KEY, '1');
      }
    }
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}
